<mat-toolbar id="tol">
<!--     <a routerLink="/" >{{appName}}</a> -->    
<!-- <a routerLink="/" id="banner"><img src="../../../../assets/iconoPPal.jpeg" alt="ldm"></a> -->
<a routerLink="/" id="banner">Astronomium</a>
<span class="fill-remaining-space"></span>

    <a routerLink="/admin" routerLinkActive="active" *ngIf="permitido">
        <button mat-button>Admin</button>
    </a>


    <a target="_blank" href="https://www.facebook.com/" routerLinkActive="active">
        <i class="fa fa-facebook" aria-hidden="true"></i>
    </a>
    &nbsp;    &nbsp;  

    <a target="_blank" href="https://www.instagram.com/" routerLinkActive="active">
        <i class="fa fa-instagram" aria-hidden="true"></i>
    </a>
    &nbsp;&nbsp;
    <a target="_blank" href="https://twitter.com/" routerLinkActive="active">
        <i class="fa fa-twitter" aria-hidden="true"></i>
    </a>
    &nbsp;
    <a *ngIf="authSvc.userData | async; else showlogin" (click)="onLogout()">
        <button mat-button id="logout">LogOut</button>
    </a>
    <ng-template #showlogin>
        <a routerLink="/login" routerLinkActive="active">
            <button mat-button id="login">Login</button>
        </a>
    </ng-template>

</mat-toolbar>